<ng-container class="flex flex-col" *ngIf="this.serviceLaneFacade.oemDashboardData$ | async as toyotaDashboardData">
  <ng-container *ngFor="let campaign of toyotaDashboardData.campaigns">
    <div class="flex flex-col alert-block">
      <div class="flex flex-row place-content-start place-items-center mb-1">
        <div class="flex place-content-center place-items-center danger">
          <mat-icon class="flex place-content-center place-items-center text-base pb-1">warning</mat-icon>
        </div>
        <span class="font-medium ml-2 text-base"> {{campaign.campaignNumber}} </span>
        <!-- <span *ngIf="alert.CampaignDate != null; else noCampaignDate" class="campaign-info"> · Campaign date is {{alert.CampaignDate | moment:
<ng-container fxLayout="column"
  *ngIf="serviceLaneFacade.toyotaDashboardData$ | async as dashboardData; else dashboardLoading">
  <div *ngIf="dashboardData.error === null">
    <ng-container *ngFor="let campaign of dashboardData?.campaigns">
      <div fxLayout="column" class="alert-block" style="margin-top: 24px;">
        <div fxLayout="row" style="margin-bottom:4px;" fxLayoutAlign="start center">
          <div fxLayoutAlign="center center" class="danger">
            <mat-icon style="font-size:16px;padding-bottom: 3px;" fxLayoutAlign="center center">warning</mat-icon>
          </div>
          <span style="font-weight:500;margin-left:8px;font-size:16px;"> {{campaign.campaignNumber}} </span>
          <!-- <span *ngIf="alert.CampaignDate != null; else noCampaignDate" class="campaign-info"> · Campaign date is {{alert.CampaignDate | moment:
        'MMM DD, YYYY'}} </span> -->

      </div>
      <div fxLayoutAlign="start start" class="pl-8">
        <span class="primary-bullet">·</span>
        <span>{{campaign.opCode}} - {{campaign.opCodeDescription}} </span>
      </div>
    </div>
    <div class="flex place-content-start place-items-start pl-8">
      <span class="primary-bullet">·</span>
      <span>{{campaign.opCode}} - {{campaign.opCodeDescription}} </span>

    </div>
  </ng-container>

  <ng-template #dashboardLoading>
    <ng-container fxLayout="column">
      <div class="alerts-container py-0 px-4" id="alertsContainer">
        <div fxLayout="column" class="alert-block">
          <div class="flex flex-row mb-1" fxLayoutAlign="start center">
            <div class="animated-background h-6 w-6 my-1.5 mr-0 ml-2 rounded-xl">
            </div>
            <span class="animated-background h-4 w-1/3 my-1.5 mr-0 ml-2 rounded"></span>
          </div>
          <div fxLayoutAlign="start start" class="pl-8">
            <span class="animated-background h-4 w-1/5 my-1.5 mr-0 ml-2 rounded"></span>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-template>